'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import Skeleton from 'react-loading-skeleton';

import Container from '@/components/@base/container';
import Props from '@/components/app/archive/components/ads-banner/type';
import {
  getArchiveInfoQueryOptions,
  useGetArchiveAdsBanner,
} from '@/components/app/archive/services/hooks';
import { Banner } from '@/components/shared/components/cards';
import { BANNER_TYPE } from '@/components/shared/components/cards/banner/type';
import { useIncrementAdvertisementClick } from '@/components/shared/services/hooks';

export default function AdsBanner({ slug, type }: Props) {
  const { data: archiveInfo } = useSuspenseQuery(getArchiveInfoQueryOptions(slug, type));
  const { data: adsBannerData, isPending } = useGetArchiveAdsBanner(
    archiveInfo?.id,
    !!archiveInfo?.id,
  );
  const { mutate: incrementAdvertisementClick } = useIncrementAdvertisementClick();

  return (
    <Container center className='hidden pt-10 pb-4 md:flex'>
      {isPending ? (
        <Skeleton width={277} height={125} className='rounded-xl' />
      ) : (
        !!adsBannerData &&
        adsBannerData.bannerImg?.publicLink && (
          <Banner
            image={adsBannerData.bannerImg.publicLink}
            title={adsBannerData.bannerTitle}
            type={BANNER_TYPE.IMAGE}
            link={adsBannerData.bannerLink}
            target='_blank'
            onClick={() => incrementAdvertisementClick(adsBannerData.id)}
            className='shadow-0 border-[1.5px] border-white object-cover'
            width={277}
            height={125}
          />
        )
      )}
    </Container>
  );
}
